var map = {
	"./en.json": "yZm8",
	"./es.json": "vnEV",
	"./fr.json": "kV3b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "egcc";


//////////////////
// WEBPACK FOOTER
// ./src/lang [a-z0-9]+\.json$/
// module id = egcc
// module chunks = 1